// Source: https://gist.github.com/ben-rogerson/b4b406dffcc18ae02f8a6c8c97bb58a8

import React, { useState, useEffect, createContext, useContext } from 'react';

const defaultValue = {};

const ScreenSizeContext = createContext(defaultValue);

export const ScreenSizeProvider: React.ElementType = ({ children, screens }) => {
  const [queryMatch, setQueryMatch] = useState({});

  useEffect(() => {
    const mediaQueryLists: any = {};
    let isAttached = false;

    const mediaData = Object.entries(screens).map(([name, media]) => [name, `(min-width: ${media})`]);

    const handleQueryListener = () => {
      const updatedMatches = mediaData.reduce(
        (acc, [name]) => ({
          ...acc,
          [name]: Boolean(mediaQueryLists[name] && mediaQueryLists[name].matches),
        }),
        {},
      );
      setQueryMatch(updatedMatches);
    };

    if (window && window.matchMedia) {
      const matches: any = {};

      mediaData.forEach(([name, media]) => {
        if (typeof media !== 'string') {
          matches[name] = false;
          return;
        }
        mediaQueryLists[name] = window.matchMedia(media);
        matches[name] = mediaQueryLists[name].matches;
      });

      setQueryMatch(matches);
      isAttached = true;

      mediaData.forEach(([name, media]) => {
        if (typeof media !== 'string') return;
        mediaQueryLists[name].addListener(handleQueryListener);
      });
    }

    return () => {
      if (!isAttached) return;
      mediaData.forEach(([name, media]) => {
        if (typeof media !== 'string') return;
        mediaQueryLists[name].removeListener(handleQueryListener);
      });
    };
  }, [screens]);

  return <ScreenSizeContext.Provider value={queryMatch}>{children}</ScreenSizeContext.Provider>;
};

export const useScreenSize = () => {
  const context: any = useContext(ScreenSizeContext);
  if (context === defaultValue) {
    throw new Error('useScreenSize must be used within a ScreenSizeProvider');
  }

  return {
    min: (size: any) => context[size],
  };
};
